module.exports = __webpack_public_path__ + "img/header_middle_bg.167e94d6.png";